export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-wireframes-a4e2cb0226b1332ed26e2d9f41115c40.png";